import { create } from 'zustand';

interface AddTechnicianModalToObjectState {
  objectSlug?: string;
  open: (slug: string) => void;
}

export const useAddTechnicianToObjectModalStore = create<AddTechnicianModalToObjectState>(set => ({
  objectSlug: undefined,
  open: (objectSlug: string) => set({ objectSlug }),
}));
